// src/components/LabelPreviewModal.jsx
import React from "react";
import "./Modal.css";
import "./LabelPreviewModal.css";
import PropTypes from "prop-types";

export default function LabelPreviewModal({ labelData, onPrint, onClose }) {
  if (!labelData) return null;

  return (
    <div className="modal-overlay" role="button" tabIndex={0} onClick={onClose} onKeyDown={(e) => { if (e.key === "Escape") onClose(); }}>  {/* NOSONAR */}
      <div
        className="modal-box label-preview-box"
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <h2 className="modal-title">Label Preview</h2>
        <p style={{ color: "#666", fontSize: "0.85rem", margin: "0 0 1rem" }}>
          Avery 6427 &mdash; 1.75&Prime; &times; 0.75&Prime;
        </p>

        {/* Label rendered at 3× scale */}
        <div className="label-preview">
          <img
            className="label-preview-qr"
            src={`data:image/png;base64,${labelData.qr_b64}`}
            alt="QR code"
          />
          <div className="label-preview-text">
            <span className="label-preview-id">{labelData.label_id}</span>
            <span className="label-preview-desc">{labelData.descriptor || labelData.name}</span>
            {(() => {
              if (labelData.grade != null) return <span className="label-preview-line3">{labelData.grade}</span>;
              if (labelData.inscription) return <span className="label-preview-line3">{labelData.inscription}</span>;
              if (labelData.set_type || labelData.created_at) return (
                <span className="label-preview-line3">
                  {[labelData.set_type, labelData.created_at].filter(Boolean).join(" · ")}
                </span>
              );
              return null;
            })()}
            {labelData.notes && (
              <span className="label-preview-notes">{labelData.notes}</span>
            )}
          </div>
        </div>

        <div className="modal-actions" style={{ marginTop: "1.5rem" }}>
          <button className="nav-btn" onClick={onPrint}>
            Print Label
          </button>
          <button className="nav-btn secondary" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

LabelPreviewModal.propTypes = {
  labelData: PropTypes.object.isRequired,
  onPrint: PropTypes.func,
  onClose: PropTypes.func.isRequired,
};
